import { Box, Stack, Typography } from "@mui/material";
import { SocketContext } from "./../../context/socket";

import React, { useContext, useState } from "react";
export default function Online({
  notext,
  className,
  onClick,
  count,
  playListId,
  senderUserId,
}) {
  const socket = useContext(SocketContext).Socket;
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [isOnline, setIsOnline] = useState(false);
  let roomId = null;
  React.useEffect(() => {
    socket.on("onlineuser", (users) => {
      setOnlineUsers([...users]);
    });
    socket.on("online_direct", (users) => {
      if (users.length && roomId === users[0]["roomId"]) {
        const online = users.filter((user) => {
          return (
            user["user"]["_id"] === senderUserId && user["roomId"] === roomId
          );
        });
        setIsOnline(online.length > 0 ? true : false);
      }
    });
    socket.on("id", (msg) => {
      if (msg && !roomId) {
        roomId = msg["roomId"];
      }
    });
  }, [socket]);
  React.useEffect(() => {
    return () => {
      setOnlineUsers([]);
      setIsOnline(false);
    };
  }, []);
  return (
    <Stack
      title={className ? "click to see online users" : ""}
      onClick={(e) => {
        onClick ? onClick(onlineUsers) : e.preventDefault();
      }}
      className={(notext ? "_chat_online " : "") + className ? className : ""}
      direction="row"
      spacing={1}
      alignItems="center"
    >
      <Box
        sx={{
          width: "8px",
          height: "8px",
          backgroundColor:
            onlineUsers.length || isOnline ? "#2CF488" : "transparent",
          borderRadius: "50%",
        }}
      ></Box>
      {notext ? null : (
        <Typography className="fs-12">{onlineUsers.length} online</Typography>
      )}
    </Stack>
  );
}
